var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.faq
    ? _c("div", { staticClass: "delivery-faq-wrapper" }, [
        _c(
          "section",
          { staticClass: "faq", attrs: { "data-assetkey": "faq" } },
          [
            _vm.heading
              ? _c("div", { staticClass: "faq__heading" }, [
                  _c("h2", [_vm._v(_vm._s(_vm.heading))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.intro
              ? _c("div", {
                  staticClass: "faq__paragraph",
                  domProps: { innerHTML: _vm._s(_vm.intro) },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "faq__lines" },
              _vm._l(_vm.faq || [], function (item, index) {
                return item.faq_question && item.faq_answer
                  ? _c("details", { key: index }, [
                      _c("summary", { staticClass: "h5" }, [
                        _c("span", [
                          _c("h3", { staticClass: "expandable-list-heading" }, [
                            _vm._v(_vm._s(item.faq_question)),
                          ]),
                          _vm._v(" "),
                          _c("span", { staticClass: "expandable-list-toggle" }),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("section", {
                        staticClass: "expandable-list-content",
                        domProps: { innerHTML: _vm._s(item.faq_answer) },
                      }),
                    ])
                  : _vm._e()
              }),
              0
            ),
          ]
        ),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }